import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetAcknowledgementById = createAsyncThunk(
  "Acknowledgement/GetAcknowledgementById",
  async (applicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Acknowledgement/GetAcknowledgementById",
        {
          applicationInformationId: applicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateAcknowledgement = createAsyncThunk(
  "Acknowledgement/UpdateAcknowledgement",
  async (model, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Acknowledgement/UpdateAcknowledgement",
        model
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
console.log(model,"model");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const Acknowledgement = createSlice({
  name: "Acknowledgement",
  initialState: {
    Acknowledgement: {},
    loadingAcknowledgement: false,
    errorAcknowledgement: null,

    UpdateAcknowledgementDATA: {},
    loadingUpdateAcknowledgementDATA: false,
    errorUpdateAcknowledgementDATA: null,
  },
  reducers: {
    SetAcknowledgement: (state, action) => {
      state.Acknowledgement = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAcknowledgementById.pending, (state, action) => {
        state.loadingAcknowledgement = true;
        state.Acknowledgement = action.payload;
        state.errorAcknowledgement = null;
      })
      .addCase(GetAcknowledgementById.fulfilled, (state, action) => {
        state.loadingAcknowledgement = false;
        state.Acknowledgement = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAcknowledgementById.rejected, (state, action) => {
        state.loadingAcknowledgement = false;
        state.errorAcknowledgement = action.payload;
      })

      .addCase(UpdateAcknowledgement.pending, (state, action) => {
        state.loadingUpdateAcknowledgementDATA = true;
        state.UpdateAcknowledgementDATA = action.payload;
        state.errorUpdateAcknowledgementDATA = null;
      })
      .addCase(UpdateAcknowledgement.fulfilled, (state, action) => {
        state.loadingUpdateAcknowledgementDATA = false;
        state.UpdateAcknowledgementDATA = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateAcknowledgement.rejected, (state, action) => {
        state.loadingUpdateAcknowledgementDATA = false;
        state.errorUpdateAcknowledgementDATA = action.payload;
      });
  },
});
export const { SetAcknowledgement } = Acknowledgement.actions;

export default Acknowledgement.reducer;
